var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBusinessIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.8462 62H62V30.4615L35.8462 25.0769M35.8462 62V25.0769M35.8462 62H25.0769M35.8462 25.0769V8.15385L2 2V62H12.7692M12.7692 62V45.8462H25.0769V62M12.7692 62H25.0769M11.2308 38.1538H14.3077M23.5385 38.1538H26.6154M11.2308 30.4615H14.3077M23.5385 30.4615H26.6154M26.6154 22.7692H23.5385M14.3077 22.7692H11.2308M11.2308 15.0769H14.3077M23.5385 15.0769H26.6154M46.6154 38.1538H50.4615M50.4615 45.8462H46.6154M46.6154 53.5385H50.4615",
    stroke: "#1347D7",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessIcon);
export default __webpack_public_path__ + "static/media/businessIcon.28922405a3ad6021c2b28f0c59646580.svg";
export { ForwardRef as ReactComponent };